import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (
  currentPage,
  perPage,
  search,
  searchContactNo,
  status,
) => {
  try {
    return await GET(
      `/admin/management/change-password-request?page=${currentPage || 1}&per_page=${
        perPage || 10
      }&name=${search || ""}&contact=${searchContactNo || ""}&status=${status || ""}`,
    );
  } catch (error) {
    console.error("Error fetching Password Change Request list:", error);
    throw error;
  }
};

export const Status = async (id) => {
  try {
    return await POST(`/admin/management/change-password-request/${id}`);
  } catch (error) {
    console.error(`Error updating status for Master ${id}:`, error);
    throw error;
  }
};
